import { inject } from 'mobx-react'
import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Page_settings } from '../../config/page_settings'
import { rootStore } from '../../mobx/store'
import strings from '../../lang/strings'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import { MenuMyData } from '../../config/page_route'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import TabHeader from '../../components/control/table/tab_header'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ReactPaginate from 'react-paginate'
import { customDateFormat, drawTableBJPointCell, drawTableArticleType, drawTableTitleCell } from '../../helper/common'
import { PAGECOUNT } from '../../config/const'
import ConfirmButton from '../../components/control/button/confirm_button'
import { tabInfo } from '../../config/constTable'
import DropdownRegister from '../../components/dropdown/register_drop'

const DataList = (props) => {
  const context = useContext(Page_settings)

  const tabList = [tabInfo.bjMyPageGameArticle]
  let [tabIndex, setTabIndex] = useState(0)
  let [dataList, setDataList] = useState(Array.from({ length: tabList.length }, () => []))
  let [pageCount, setPageCount] = useState(Array.from({ length: tabList.length }, () => 1))
  let [page, setPage] = useState(Array.from({ length: tabList.length }, () => 1))

  const active = 0

  useEffect(() => {

  }, [])

  useEffect(() => {
    getData(1, tabIndex)
    if (tabList[tabIndex].table_type !== "daily") return
    // context.checkDailyPopup()
  }, [tabIndex])

  const getData = (page, index) => {
    const cate = tabList[index].cate
    context.post('data/data_list', { mb_id: rootStore.getMe.mb_id, cate: cate, page: page, count: PAGECOUNT },
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setDataList(prev => prev.map((it, idx) => { return idx === index ? response.list : it }))
        setPageCount(prev => prev.map((it, idx) => { return idx === index ? response.page_count : it }))
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const onNew = (idx) => {
    let urls = ['/my_data/analyst_new_game', '/my_data/analyst_new_betting', '/my_data/analyst_new_victory', '/my_data/analyst_new_daily', '/my_data/bj_new/0', '/my_data/bj_new/1', '/my_data/bj_new']
    props.history.push(urls[idx], { data: null })
  }

  const onDetail = (result) => {
    props.history.push(tabList[tabIndex].url, { result: result })
  }

  const onDelete = (info) => {
    if (info.other_purchased == 1) {
      // context.showAlert(strings.unable_delete)
      return
    }
    context.showConfirm(strings.ask_delete, (val) => {
      if (!val) return
      context.post('data/data_delete', { dat_id: info.dat_id },
        () => {
          setPage(prev => prev.map((it, idx) => { return idx === tabIndex ? 1 : it }))
          getData(1, tabIndex)
        },
        true,
        err => {
          setTimeout(() => { context.showAlert(err.msg) }, 500)
        }
      )
    })
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(prev => prev.map((it, idx) => { return idx === tabIndex ? nextPage : it }))
    getData(nextPage, tabIndex)
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMyData} active={active} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.data_list} pageMenu1={strings.main} pageMenu2={strings.my_analyst} pageMenu={strings.data_list} />
          <div className='mt-30 sm-mt-15 d-flex align-items-center'>
            <div className='fs-20 f-b color-3a3335 flex-full sm-invisible'>{strings.analyst_data}</div>
            <DropdownRegister onRegister={(idx) => { onNew(idx) }} />
          </div>
          <div className='fs-15 sm-fs-16 f-b color-3a3335 sm-inherit'>{strings.analyst_data}</div>
          <TabHeader className={'mt-20 sm-none'} selected={tabIndex} tabs={tabList.map(item => item.customTitle || item.title)} onChange={(id) => { setTabIndex(id) }} />
          <select className='form-control hx-64 sm-mt-15 sm-inherit custom_select' value={tabIndex} onChange={(e) => { setTabIndex(parseInt(e.target.value)) }}>
            {tabList.map((it, idx) => { return (<option value={idx} key={idx}>{it.title}</option>) })}
          </select>
          {tabList.map((it, idx) => {
            return (
              <div key={idx} className={tabIndex === idx ? '' : 'hide'}>
                <div className='shadow-div position-relative'>
                  <PerfectScrollbar className='div_sale sm-mt-20 mb-40'>
                    <TableHeader className={'bg-white'} headers={it.header} />
                    {
     
                      it.table_type == "bj" && dataList[idx].map((info, index) => {
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point' >
                            <TableCell
                              onClick={() => onDetail(info)}
                              value={null}
                              className={it.header[0].class}
                              center={it.header[0].center}
                              child={drawTableArticleType(info.dat_cate)}
                            />
                            <TableCell
                              onClick={() => onDetail(info)}
                              value={customDateFormat(info.dat_start)}
                              className={it.header[1].class}
                              center={it.header[1].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => onDetail(info)}
                              value={info.dat_title}
                              className={it.header[2].class}
                              center={it.header[2].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              onClick={() => onDetail(info)}
                              value={customDateFormat(info.dat_updatedat)}
                              className={it.header[3].class}
                              center={it.header[3].center}
                              child={null}
                            />
                            <TableCell
                              value={''}
                              className={it.header[4].class}
                              center={it.header[4].center}
                              child={
                                <div className={'d-center w-100 h-100'}>
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m'}
                                    onClick={(evt) => { onDelete(info); }}
                                    text={strings.delete}
                                  />
                                </div>
                              }
                            />
                          </div>
                        )
                      })
                      
                    }
                    {
                      it.table_type == "daily" && dataList[idx].map((info, index) => {
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point'>
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                              className={it.header[0].class}
                              center={it.header[0].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={customDateFormat(info.dat_start)}
                              className={it.header[1].class}
                              center={it.header[1].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_title}
                              className={it.header[2].class}
                              center={it.header[2].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={customDateFormat(info.dat_createdat)}
                              className={it.header[3].class}
                              center={it.header[3].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_po == 0 ? strings.free_price : ''}
                              className={it.header[4].class}
                              center={it.header[4].center}
                              child={drawTableBJPointCell(info.dat_po, info.dat_po, 0, 1)}
                            />
                            <TableCell
                              value={''}
                              className={it.header[5].class}
                              center={it.header[5].center}
                              child={
                                <div className={'d-center w-100 h-100'}>
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m' }
                                    onClick={() => { onDelete(info); }}
                                    text={strings.delete}
                                  />
                                </div>
                              }
                            />
                          </div>
                        )
                      })
                    }
                    {/* {
                    dataList[idx].map((info, index) => {
                      if (tabList[idx].table_type ===  "analyst") {
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point'>
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                              className={tbAnalystEditHeaders[0].class}
                              center={tbAnalystEditHeaders[0].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.sk_name ?? '-'}
                              className={tbAnalystEditHeaders[1].class}
                              center={tbAnalystEditHeaders[1].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={customDateFormat(info.dat_start)}
                              className={tbAnalystEditHeaders[2].class}
                              center={tbAnalystEditHeaders[2].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_title}
                              className={tbAnalystEditHeaders[3].class}
                              center={tbAnalystEditHeaders[3].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.mb_nick}
                              className={tbAnalystEditHeaders[4].class}
                              center={tbAnalystEditHeaders[4].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_po == 0 ? strings.free_price : ''}
                              className={tbAnalystEditHeaders[5].class}
                              center={tbAnalystEditHeaders[5].center}
                              child={drawTableBJPointCell(info.dat_po, info.dat_po, 0, 1)}
                            />
                            <TableCell
                              value={''}
                              className={tbAnalystEditHeaders[6].class}
                              center={tbAnalystEditHeaders[6].center}
                              child={
                                <div className={'d-center w-100 h-100'}>
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m' }
                                    onClick={() => { onDelete(info); }}
                                    text={strings.delete}
                                  />
                                </div>
                              }
                            />
                          </div>
                        )
                      } else if (tabList[idx].table_type ===  "daily") {
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point'>
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                              className={tbDailyEditHeaders[0].class}
                              center={tbDailyEditHeaders[0].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={customDateFormat(info.dat_start)}
                              className={tbDailyEditHeaders[1].class}
                              center={tbDailyEditHeaders[1].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_title}
                              className={tbDailyEditHeaders[2].class}
                              center={tbDailyEditHeaders[2].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.mb_nick}
                              className={tbDailyEditHeaders[3].class}
                              center={tbDailyEditHeaders[3].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {
                                onDetail(info)
                              }}
                              value={info.dat_po == 0 ? strings.free_price : ''}
                              className={tbDailyEditHeaders[4].class}
                              center={tbDailyEditHeaders[4].center}
                              child={drawTableBJPointCell(info.dat_po, info.dat_po, 0, 1)}
                            />
                            <TableCell
                              value={''}
                              className={tbDailyEditHeaders[5].class}
                              center={tbDailyEditHeaders[5].center}
                              child={
                                <div className={'d-center w-100 h-100'}>
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m' }
                                    onClick={() => { onDelete(info); }}
                                    text={strings.delete}
                                  />
                                </div>
                              }
                            />
                          </div>
                        )
                      } else if (tabList[idx].table_type === "bj"){
                        return (
                          <div key={index} className='tb-row clickable-row-highlight cursor-point'>
                            <TableCell
                              onClick={() => {onDetail(info)}}
                              value={null}
                              className={tbMypageBjEditHeaders[0].class}
                              center={tbMypageBjEditHeaders[0].center}
                              child={drawTableArticleType(info.dat_cate)}
                            />
                            <TableCell
                              onClick={() => {onDetail(info)}}
                              value={customDateFormat(info.dat_start)}
                              className={tbMypageBjEditHeaders[1].class}
                              center={tbMypageBjEditHeaders[1].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {onDetail(info)}}
                              value={info.dat_title}
                              className={tbMypageBjEditHeaders[2].class}
                              center={tbMypageBjEditHeaders[2].center}
                              child={drawTableTitleCell(info.dat_title, info.data_new)}
                            />
                            <TableCell
                              onClick={() => {onDetail(info)}}
                              value={info.mb_nick}
                              className={tbMypageBjEditHeaders[3].class}
                              center={tbMypageBjEditHeaders[3].center}
                              child={null}
                            />
                            <TableCell
                              onClick={() => {onDetail(info)}}
                              value={''}
                              className={tbMypageBjEditHeaders[4].class}
                              center={tbMypageBjEditHeaders[4].center}
                              child={null}
                            />
                            <TableCell
                              value={''}
                              className={tbMypageBjEditHeaders[5].class}
                              center={tbMypageBjEditHeaders[5].center}
                              child={
                                <div className={'d-center w-100 h-100'}>
                                  <ConfirmButton
                                    className={info.other_purchased === 1 ? 'bd-0 item-data-button-disabled w-100 fs-14 f-m' : 'bd-0 item-data-button w-100 fs-14 f-m' }
                                    onClick={() => { onDelete(info); }}
                                    text={strings.delete}
                                  />
                                </div>
                              }
                            />
                          </div>
                        )
                      }
                    })
                  } */}
                  </PerfectScrollbar>
                </div>
                {pageCount[idx] > 1 &&
                  <ReactPaginate
                    previousLabel={''}
                    nextLabel={''}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pageCount[idx]}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                }
              </div>
            )
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(inject('rootStore')(DataList))
